(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const GSAP_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  const ST_CDN   = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initScrollAnimation(canvas) {
    var sectionId  = canvas.dataset.sectionId;
    var baseUrl    = canvas.dataset.baseUrl;
    var version    = canvas.dataset.version;
    var frameCount = parseInt(canvas.dataset.frameCount, 10);
    var heroEl     = document.getElementById('Hero-' + sectionId);

    if (!heroEl || !canvas) return;

    var ctx = canvas.getContext('2d');
    var images = [];
    var loadedCount = 0;
    var currentFrame = 0;
    var rafId = null;

    function padNum(n) {
      return String(n).padStart(3, '0');
    }

    function buildUrl(i) {
      return baseUrl + padNum(i) + '.jpg?v=' + version;
    }

    function resizeCanvas() {
      canvas.width  = heroEl.offsetWidth;
      canvas.height = heroEl.offsetHeight;
      if (images[currentFrame] && images[currentFrame].complete) {
        drawFrame(currentFrame);
      }
    }

    function drawFrame(index) {
      var img = images[index];
      if (!img || !img.complete || img.naturalWidth === 0) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var cw = canvas.width;
      var ch = canvas.height;
      var iw = img.naturalWidth;
      var ih = img.naturalHeight;
      var scale = Math.max(cw / iw, ch / ih);
      var dw = iw * scale;
      var dh = ih * scale;
      var dx = (cw - dw) / 2;
      var dy = (ch - dh) / 2;
      ctx.drawImage(img, dx, dy, dw, dh);
    }

    function renderFrame(index) {
      var frame = Math.round(index);
      if (frame === currentFrame && loadedCount > 0) return;
      currentFrame = frame;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        drawFrame(currentFrame);
        rafId = null;
      });
    }

    resizeCanvas();

    var preloadBatch = 12;
    var preloadQueue = [];
    for (var i = 1; i <= frameCount; i++) { preloadQueue.push(i); }

    function loadNext() {
      if (preloadQueue.length === 0) return;
      var idx = preloadQueue.shift();
      var img = new Image();
      img.src = buildUrl(idx);
      images[idx - 1] = img;
      img.onload = function () {
        loadedCount++;
        if (loadedCount === 1) {
          resizeCanvas();
          drawFrame(0);
        }
        loadNext();
      };
      img.onerror = function () { loadNext(); };
    }

    for (var b = 0; b < preloadBatch; b++) { loadNext(); }

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    gsap.registerPlugin(ScrollTrigger);

    var scrollHeight = window.innerHeight * 4;
    heroEl.style.height = scrollHeight + 'px';
    heroEl.classList.add('hero--scroll-anim-active');

    var stickyWrapper = document.createElement('div');
    stickyWrapper.style.cssText = [
      'position:sticky',
      'top:0',
      'width:100%',
      'height:' + window.innerHeight + 'px',
      'overflow:hidden',
      'z-index:1'
    ].join(';');

    var container = heroEl.querySelector('.hero__container');
    heroEl.insertBefore(stickyWrapper, container);
    stickyWrapper.appendChild(container);

    canvas.style.height = window.innerHeight + 'px';
    canvas.width  = heroEl.offsetWidth;
    canvas.height = window.innerHeight;

    gsap.to({ frame: 0 }, {
      frame: frameCount - 1,
      ease: 'none',
      snap: { snapTo: 1, duration: 0 },
      scrollTrigger: {
        trigger: heroEl,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.5,
        invalidateOnRefresh: true
      },
      onUpdate: function () {
        renderFrame(Math.round(this.targets()[0].frame));
      }
    });

    var ro = new ResizeObserver(function () {
      canvas.width  = heroEl.offsetWidth;
      canvas.height = window.innerHeight;
      stickyWrapper.style.height = window.innerHeight + 'px';
      drawFrame(currentFrame);
      ScrollTrigger.refresh();
    });
    ro.observe(heroEl);
  }

  function setup() {
    var canvases = document.querySelectorAll('[id^="hero-frame-canvas-"]');
    if (!canvases.length) return;

    loadScript(GSAP_CDN)
      .then(function () { return loadScript(ST_CDN); })
      .then(function () {
        canvases.forEach(function (canvas) {
          initScrollAnimation(canvas);
        });
      })
      .catch(function (err) {
        console.warn('[Hero Frame] Failed to load GSAP:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var canvas = e.target && e.target.querySelector('[id^="hero-frame-canvas-"]');
    if (!canvas) return;
    loadScript(GSAP_CDN)
      .then(function () { return loadScript(ST_CDN); })
      .then(function () { initScrollAnimation(canvas); })
      .catch(function (err) { console.warn('[Hero Frame] reload failed:', err); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milkso-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Header: scroll glaze + mobile menu ── */
  function initHeader(headerEl) {
    if (headerEl.dataset.mhdrInit) return;
    headerEl.dataset.mhdrInit = '1';

    // Set CSS custom properties for header heights
    var height = headerEl.offsetHeight;
    document.body.style.setProperty('--header-height', height + 'px');
    document.body.style.setProperty('--header-group-height', height + 'px');

    var toggle   = headerEl.querySelector('[id^="mhdr-toggle-"]');
    var drawer   = headerEl.querySelector('[id^="mhdr-mobile-"]');
    var scrolled = false;

    /* Glassmorphism on scroll */
    function onScroll() {
      var now = window.scrollY > 20;
      if (now !== scrolled) {
        scrolled = now;
        headerEl.classList.toggle('is-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mobile menu toggle */
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        drawer.setAttribute('aria-hidden', String(open));
        drawer.classList.toggle('is-open', !open);
        toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      });

      /* Close on outside click */
      document.addEventListener('click', function (e) {
        if (!headerEl.contains(e.target) && drawer.classList.contains('is-open')) {
          toggle.setAttribute('aria-expanded', 'false');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.classList.remove('is-open');
          toggle.setAttribute('aria-label', 'Open menu');
        }
      });

      /* Close on mobile link click */
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          toggle.setAttribute('aria-expanded', 'false');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.classList.remove('is-open');
          toggle.setAttribute('aria-label', 'Open menu');
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[id^="milkso-header-"]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target && e.target.querySelector('[id^="milkso-header-"]');
    if (h) initHeader(h);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milkso-hero"] && !Shopify.designMode) return;
  try {
    
/* ── Milkso Hero: GSAP-pin scroll animation (desktop + mobile) ── */
(function () {
  'use strict';

  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_SRC   = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) { res(); return; }
      var s = document.createElement('script');
      s.src = src; s.defer = true;
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  /* ─────────────────────────────────────────────────────────────
   * HIGH-QUALITY CANVAS PLAYER
   * Uses devicePixelRatio for Retina sharpness.
   * ───────────────────────────────────────────────────────────── */
  function createPlayer(canvas) {
    var ctx         = canvas.getContext('2d');
    var baseUrl     = canvas.dataset.baseUrl;
    var version     = canvas.dataset.version;
    var totalFrames = parseInt(canvas.dataset.frameCount, 10);
    var images      = new Array(totalFrames).fill(null);
    var loaded      = 0;
    var curFrame    = 0;
    var rafId       = null;
    var dpr         = Math.min(window.devicePixelRatio || 1, 3);
    var BATCH       = 12;
    var queue       = [];

    for (var n = 1; n <= totalFrames; n++) queue.push(n);

    function pad(n) { return ('000' + n).slice(-3); }
    function url(i) { return baseUrl + pad(i) + '.jpg?v=' + version; }

    function resize() {
      var parent = canvas.parentElement;
      var w = parent ? parent.offsetWidth  : window.innerWidth;
      var h = parent ? parent.offsetHeight : window.innerHeight;
      canvas.style.width  = w + 'px';
      canvas.style.height = h + 'px';
      canvas.width  = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
    }

    function drawAt(idx) {
      var img = images[idx];
      if (!img || !img.complete || !img.naturalWidth) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      var cw = canvas.width,  ch = canvas.height;
      var iw = img.naturalWidth, ih = img.naturalHeight;
      var s  = Math.max(cw / iw, ch / ih);
      var dx = (cw - iw * s) * 0.5;
      var dy = (ch - ih * s) * 0.5;
      if (window.innerWidth < 990) {
        dy = dy - (ch * 0.08);
      }
      ctx.drawImage(img, dx, dy, iw * s, ih * s);
    }

    function render(progress) {
      var idx = Math.max(0, Math.min(totalFrames - 1, Math.round(progress * (totalFrames - 1))));
      if (idx === curFrame && loaded > 0) return;
      curFrame = idx;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        drawAt(curFrame);
        rafId = null;
      });
    }

    function loadNext() {
      if (!queue.length) return;
      var i   = queue.shift();
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.src         = url(i);
      images[i - 1]   = img;
      img.onload = function () {
        loaded++;
        if (loaded === 1) { resize(); drawAt(0); }
        loadNext();
      };
      img.onerror = function () { loadNext(); };
    }

    resize();
    for (var b = 0; b < BATCH; b++) loadNext();

    return {
      render:      render,
      resize:      resize,
      drawCurrent: function () { drawAt(curFrame); },
      total:       totalFrames
    };
  }

  /* ─────────────────────────────────────────────────────────────
   * INIT SECTION
   *
   * KEY FIX: We use GSAP's pin:true on .mhero__sticky.
   * GSAP sets position:fixed on the element when pinning,
   * which works regardless of parent overflow:hidden/auto.
   * CSS position:sticky CANNOT work when any ancestor has
   * overflow:hidden — GSAP pin bypasses this completely.
   * ───────────────────────────────────────────────────────────── */
  function initSection(sectionEl) {
    if (sectionEl.dataset.mheroInit) return;
    sectionEl.dataset.mheroInit = '1';

    var gsap          = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    var stickyEl  = sectionEl.querySelector('.mhero__sticky');
    var canvas    = sectionEl.querySelector('.mhero__canvas');
    var content   = sectionEl.querySelector('[id^="mhero-content-"]');
    var brand     = sectionEl.querySelector('.mhero__brand');
    var chars     = sectionEl.querySelectorAll('.mhero__char');
    var subtitle  = sectionEl.querySelector('.mhero__subtitle');
    var desc      = sectionEl.querySelector('.mhero__desc');
    var ctaRow    = sectionEl.querySelector('.mhero__cta-row');

    if (!stickyEl) return;

    /* ── Read scroll scale from data attribute ── */
    var scrollScale   = parseFloat(sectionEl.dataset.scrollScale) || 4;
    /* Extra scroll distance beyond the viewport height itself */
    var extraScrollPx = Math.round(window.innerHeight * (scrollScale - 1));

    /* ── Determine scroller container ── */
    var scrollerEl = window;
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper && window.innerWidth >= 990) {
      scrollerEl = pageWrapper;
    }

    /* ── Entrance animation (fires once on load) ── */
    var entrance = gsap.timeline({
      defaults: { ease: 'power3.out' },
      delay: 0.1
    });

    if (brand)   entrance.to(brand,    { opacity: 1, y: 0, duration: 0.7 });
    if (chars.length) {
      entrance.to(chars, { opacity: 1, y: 0, duration: 0.65, stagger: 0.07,
                           ease: 'power4.out' }, '-=0.35');
    }
    if (subtitle) entrance.to(subtitle, { opacity: 1, y: 0, duration: 0.6  }, '-=0.3');
    if (desc)     entrance.to(desc,     { opacity: 1, y: 0, duration: 0.55 }, '-=0.3');
    if (ctaRow)   entrance.to(ctaRow,   { opacity: 1, y: 0, duration: 0.5  }, '-=0.28');

    /* ── Canvas player ── */
    var player = canvas ? createPlayer(canvas) : null;

    /* ─────────────────────────────────────────────────────────
     * MAIN SCROLL TRIGGER
     *
     * pin: true  → GSAP pins stickyEl (position:fixed while
     *              the user scrolls through extraScrollPx).
     * pinSpacing → GSAP inserts a spacer div equal to
     *              extraScrollPx so the page has the right
     *              scroll height.
     * onUpdate   → receives self.progress (0 → 1) which we
     *              use to scrub frames and fade content.
     * ───────────────────────────────────────────────────────── */
    ScrollTrigger.create({
      trigger:           stickyEl,
      scroller:          scrollerEl,
      start:             'top top',
      end:               '+=' + extraScrollPx,
      pin:               true,
      pinSpacing:        true,
      anticipatePin:     1,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        var p = self.progress; /* 0 → 1 */

        /* Scrub canvas frames */
        if (player) player.render(p);

        /* Fade + lift content in first 25% of scroll */
        if (content) {
          var cp = Math.min(p / 0.25, 1);
          content.style.opacity   = String(1 - cp);
          content.style.transform = 'translateY(' + (cp * -70) + 'px)';
        }
      }
    });

    /* ── Resize observer keeps canvas sharp on resize ── */
    if (player) {
      var ro = new ResizeObserver(function () {
        player.resize();
        player.drawCurrent();
        ScrollTrigger.refresh();
      });
      ro.observe(stickyEl);
    }
  }

  /* ── Boot ── */
  function boot() {
    var sections = document.querySelectorAll('[id^="milkso-hero-"]');
    if (!sections.length) return;
    loadScript(GSAP_SRC)
      .then(function () { return loadScript(ST_SRC); })
      .then(function () { sections.forEach(initSection); })
      .catch(function (e) { console.warn('[Milkso Hero]', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector('[id^="milkso-hero-"]');
    if (!s) return;
    loadScript(GSAP_SRC)
      .then(function () { return loadScript(ST_SRC); })
      .then(function () { initSection(s); })
      .catch(function (e) { console.warn('[Milkso Hero reload]', e); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
